'use client';

import { styled } from '@mui/material';

export const TableMobileEmptyContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: 116,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(4),
  borderRadius: theme.spacing(4),
  background: theme.palette.surface2,
}));
